(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.review-carousel__track');
      if (!this.track) return;
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-direction]');
      if (!button) return;

      const step = this.track.clientWidth;
      const delta = button.dataset.direction === 'next' ? step : -step;
      this.track.scrollBy({ left: delta, behavior: 'smooth' });
    };
  }

  if (!customElements.get('review-carousel-component')) {
    customElements.define('review-carousel-component', ReviewCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class UgcGalleryComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ugc-gallery__track');
      if (!this.track) return;
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-direction]');
      if (!button) return;

      // Um eine sichtbare Breite weiterspringen, wie beim Review-Karussell
      const step = this.track.clientWidth * 0.8;
      const delta = button.dataset.direction === 'next' ? step : -step;
      this.track.scrollBy({ left: delta, behavior: 'smooth' });
    };
  }

  if (!customElements.get('ugc-gallery-component')) {
    customElements.define('ugc-gallery-component', UgcGalleryComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
